import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/correct.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-xl-6 mx-auto mb-10" }
const _hoisted_4 = { class: "card card-flush pt-3 mb-5 mb-xl-10" }
const _hoisted_5 = { class: "card-body p-10 text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rounded",
  height: "70",
  alt: "Done"
}, null, -1)
const _hoisted_7 = { class: "my-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_6,
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.message), 1),
                  _createVNode(_component_Button, {
                    label: "Go to verifications",
                    onClicked: _ctx.goToVerifications
                  }, null, 8, ["onClicked"])
                ], 64))
          ])
        ])
      ])
    ])
  ]))
}